"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeytipLayer = void 0;
var Utilities_1 = require("../../Utilities");
var KeytipLayer_base_1 = require("./KeytipLayer.base");
var KeytipLayer_styles_1 = require("./KeytipLayer.styles");
exports.KeytipLayer = (0, Utilities_1.styled)(KeytipLayer_base_1.KeytipLayerBase, KeytipLayer_styles_1.getStyles, undefined, {
    scope: 'KeytipLayer',
});
//# sourceMappingURL=KeytipLayer.js.map